<template>
  <div class="m-items">
    <b-modal id="m-items" v-model="localActive" centered hide-footer hide-header>
      <svg
        class="m-items-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeModal"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>

      <div class="m-items-title">За должностью "{{positionName}}" закреплены сотрудники</div>

      <div v-if="positionName" class="m-items-description" v-html='`Посмотреть сотрудников, закрепленных за должностью "${positionName}"?`'/>

      <div class="m-items-buttons">
        <c-button
          class="m-items-buttons-apply"
          color="white"
          :label="'Перенести в архив'"
          @click="$emit('moveToArchive')"
        />

        <c-button
          color="secondary"
          :label="'Посмотреть'"
          @click="goToEmployeesTable(postCode)"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";

export default {
  name: "m-create",

  components: {
    "c-button": Button,
    "c-input": Input,
  },

  props: [
    "active",
    "positionName",
    "postCode",
  ],

  data() {
    return {
      localActive: false,
    };
  },

  watch: {
    active(value) {
      this.localActive = value;
    },
  },


  methods: {
    closeModal() {
      this.$emit("close");
    },
    goToEmployeesTable(code) {
      this.$emit('goToEmployeesTable', code);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-items {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    color: #000000;

    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }

  &-description {
    margin-top: 20px;
    font-size: 15px;
    line-height: 120%;
    color: #000000;
    overflow-wrap: break-word;

    &-bold {
      font-weight: 500;
    }
  }

  &-select,
  &-input {
    margin-top: 23px;
  }

  &-buttons {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;

    &-apply {
      margin-right: 10px;
    }

    @media screen and (max-width: 700px) {
      margin: 40px 0 0 -20px;
      width: calc(100% + 43px);

      &-cancel {
        margin-right: 0;
      }

      & .c-button {
        width: 50%;
        border-radius: 0;
      }
    }
  }
}

::v-deep #m-items .modal-dialog {
  max-width: 590px !important;
  @media screen and (max-width: 700px) {
    max-width: 100% !important;
    margin: 0 !important;
  }
}

::v-deep #m-items___BV_modal_content_ {
  @media screen and (max-width: 700px) {
    width: 100% !important;
    height: auto;
  }
}

::v-deep #m-items___BV_modal_body_ {
  padding: 27px 34px 30px 31px;

  @media screen and (max-width: 700px) {
    padding: 27px 23px 0 20px;
  }
}
</style>
